import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ShareArticleSection } from "../ShareArticleSection";

const AcceleratingCollegeAdmissionsWithAI = () => {
  return (
    <div className="modal-content-body case-studies-blk">
      <div className="modal-section">
        <div className="flex-content header-modal-case-studies">
          <div className="logo-section-modal">
            <img
              src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/thumbnails/benilde-thumbnail-iris.png"
              alt="Scene to believe"
            />
          </div>
          <div>
            <h3>Accelerating College Admissions with AI</h3>
            <p>
              Benilde partnered with iCXeed to launch a multilingual, AI-powered
              admissions concierge that provides 24/7 guidance, reduces staff
              workload, and establishes a scalable AI foundation for the student
              lifecycle.
            </p>
            <ShareArticleSection />
          </div>
        </div>
      </div>

      {/* Opportunity & Qualification */}
      <div className="modal-section">
        <h2 className="modal-section-title">Company Snapshot:</h2>
        <p className="title-description-blk">
          Benilde partnered with iCXeed to deploy an AI-powered admissions
          concierge on its website, built on AWS Bedrock with Claude Sonnet, to
          engage prospective students across two campuses and seven academic
          programs in over 30 languages. The solution delivers 24/7,
          context-aware guidance on programs, admissions, and enrolment, reduces
          repetitive workload for admissions staff, and establishes a scalable
          AI foundation for the entire student lifecycle.
        </p>
      </div>

      {/* Proposed Solution */}
      <div className="modal-section">
        <div className="flex-content-half">
          <div>
            <h2 className="modal-section-title">Challenge:</h2>
            <p className="text-[#CDCFD3]">
              Benilde, a leading higher education institution in the
              Philippines, faced the challenge of enhancing prospective student
              engagement during critical admissions and enrolment periods. The
              institution sought to adopt enterprise-grade generative AI,
              signalling to students, parents, and industry partners that it is
              a frontrunner in adopting cutting-edge technology for real world
              application. Specifically, Benilde needed to:
            </p>
            <p className="text-[#CDCFD3]">
              <span className="font-bold text-white">
                Modernize student interactions
              </span>{" "}
              - Previous attempts at implementing AI technology had not achieved
              desired outcomes due to immature technology capabilities. The
              institution recognized the need to upgrade to cutting-edge
              generative AI solutions to deliver a modern, engaging experience.
            </p>
            <p className="text-[#CDCFD3]">
              <span className="font-bold text-white">
                Complex inquiry handling
              </span>{" "}
              - With two separate campuses and seven distinct academic programs
              (Senior High School, Undergraduate, Graduate, ETEEAP, Benilde Deaf
              School, and Continuing Education), the college required a solution
              capable of handling complex, context-aware inquiries across
              diverse student populations.
            </p>
            <p className="text-[#CDCFD3]">
              <span className="font-bold text-white">
                Provide personalized guidance
              </span>{" "}
              - Prospective students and parents needed 24/7 access to accurate
              information about available programs, admissions processes,
              enrolment requirements, campus life.
            </p>
            <p className="text-[#CDCFD3]">
              <span className="font-bold text-white">Better analytics</span> -
              Enables insights for Benilde to be able to better cater to its
              prospective students. These analytics will lead to streamlined
              processes and increased student engagement in the early stages in
              their life at Benilde.
            </p>
          </div>

          <div>
            <h2 className="modal-section-title">AWS Solution:</h2>
            <p className="text-[#CDCFD3]">
              To address these challenges, iCXeed deployed an AI-powered
              concierge service integrated directly into the Benilde website,
              leveraging AWS cloud infrastructure and advanced generative AI
              capabilities.
            </p>

            <p className="font-bold">Core Solution Architecture</p>
            <p className="font-bold">Intelligent Knowledge Base Management</p>
            <ul className="text-[#CDCFD3]">
              <li>
                • Comprehensive organization, creation, and curation of
                Benilde's institutional knowledge base
              </li>
              <li>
                • Structured information covering admissions criteria, program
                details, campus facilities, student services, and enrolment
                processes
              </li>
              <li>
                • Multi-campus support enabling differentiated responses based
                on student campus selection
              </li>
            </ul>

            <p className="font-bold">Multilingual Capability</p>
            <ul className="text-[#CDCFD3]">
              <li>
                • Support for over 30 languages to serve Benilde's diverse,
                international prospective student base
              </li>
              <li>
                • Native proficiency in Tagalog. This multilingual capability
                allows the concierge to respond naturally to queries like
                “Magkano po ang tuition?” or “Pwede ba ako mag-shift if hindi
                match ang course?” in a mix of English and Tagalog, lowering
                barriers and making the experience feel authentically Benildean.
              </li>
              <li>
                • Context-aware language selection based on user preference
              </li>
            </ul>

            <p className="font-bold">Contextual Understanding</p>
            <ul className="text-[#CDCFD3]">
              <li>
                • Advanced reasoning capabilities to understand complex,
                multi-part inquiries from prospective students and parents
              </li>
              <li>
                • Ability to maintain context throughout conversations,
                personalising responses based on student profile (e.g., program
                of interest, campus location)
              </li>
              <li>
                • Sophisticated handling of nuanced questions about admissions
                timelines, program requirements, and enrolment procedures
              </li>
            </ul>

            <p className="font-bold">Seamless Escalation</p>
            <ul className="text-[#CDCFD3]">
              <li>
                • Integration with Benilde's existing ticketing system for
                inquiries beyond the AI concierge resolution capability
              </li>
              <li>
                • Automated ticket creation preserving conversation context for
                Benilde's admissions team
              </li>
              <li>
                • Handoff mechanism ensuring no inquiry goes unanswered while
                optimizing first-contact resolution
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="outcomes-result-blk">
        <h2 className="modal-section-title">Outcomes/Results:</h2>
        <ul>
          <li>
            <div className="flex-box-blk">
              <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
              <p>Student Engagement & Satisfaction</p>
            </div>
          </li>
          <li>
            <div className="flex-box-blk">
              <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
              <p>Operational Efficiency</p>
            </div>
          </li>
          <li>
            <div className="flex-box-blk">
              <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
              <p>Enrollment Impact</p>
            </div>
          </li>
          <li>
            <div className="flex-box-blk">
              <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
              <p>Strategic Positioning</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default AcceleratingCollegeAdmissionsWithAI;
